// Literals here are the ones the admin panel already uses for these roles (settings, aiUsage, Dialog,
// SupportNotificationEmails); everything the MUI theme owns is referenced through `sx` palette keys instead.
export const tokens = (isDark: boolean) => ({
  border: isDark ? 'rgba(255,255,255,0.08)' : '#e2e8f0',
  inputBorder: isDark ? 'rgba(255,255,255,0.15)' : '#cbd5e1',
  subtle: isDark ? 'rgba(255,255,255,0.05)' : '#f1f5f9',
  muted: isDark ? '#94a3b8' : '#64748b',
  green: '#16a34a',
  greenBg: 'rgba(22,163,74,0.1)',
  greenBorder: 'rgba(22,163,74,0.45)',
  amber: '#f59e0b',
  amberBg: isDark ? 'rgba(245,158,11,0.1)' : '#fffbeb',
  amberBorder: 'rgba(245,158,11,0.6)',
  amberText: isDark ? '#fdba74' : '#92400e',
  blue: isDark ? '#93c5fd' : '#1d4ed8',
  blueBg: isDark ? 'rgba(59,130,246,0.12)' : '#eff6ff',
  blueBorder: isDark ? 'rgba(59,130,246,0.3)' : '#93c5fd',
  danger: '#ef4444',
  dangerBg: isDark ? 'rgba(239,68,68,0.1)' : '#fef2f2',
  dangerBorder: isDark ? 'rgba(239,68,68,0.3)' : '#fecaca',
  dangerText: isDark ? '#fca5a5' : '#b91c1c',
  link: isDark ? '#60a5fa' : '#2563eb',
  headBg: isDark ? 'rgba(255,255,255,0.03)' : '#f8fafc',
  track: isDark ? 'rgba(59,130,246,0.2)' : '#dbeafe',
  grid: isDark ? 'rgba(255,255,255,0.06)' : '#f1f5f9',
  axis: isDark ? '#64748b' : '#94a3b8',
})

export type Tokens = ReturnType<typeof tokens>

export const cardSx = (t: Tokens) => ({
  border: `1px solid ${t.border}`,
  borderRadius: '12px',
  bgcolor: 'background.paper',
})
